module.exports = __webpack_public_path__ + "img/share_icon2.3b3a1df1.png";